import { createSlice } from "@reduxjs/toolkit";

interface ISpeechDetectorReducerState {
  speechDetected: boolean;
  speechDetectedAt: number;
  soundDetected: boolean;
  soundDetectedAt: number;
}

export const speechDetectorReducerInitialState: ISpeechDetectorReducerState = {
  speechDetected: false,
  soundDetected: false,
  speechDetectedAt: 0,
  soundDetectedAt: 0,
};

export const speechDetectorSlice = createSlice({
  name: "streaming",
  initialState: speechDetectorReducerInitialState,
  reducers: {
    detectedSpeech: (state) => {
      state.speechDetected = true;
      state.speechDetectedAt = Date.now();
    },

    noSpeechDetected: (state) => {
      state.speechDetected = false;
      state.speechDetectedAt = Date.now();
    },

    stopDetectingSpeech: (state) => {
      state.speechDetected = false;
      state.speechDetectedAt = 0;
    },

    detectedSound: (state) => {
      state.soundDetected = true;
      state.soundDetectedAt = Date.now();
    },

    noSoundDetected: (state) => {
      state.soundDetected = false;
      state.soundDetectedAt = Date.now();
    },

    stopDetectingSound: (state) => {
      state.soundDetected = false;
      state.soundDetectedAt = 0;
    },
  },
});

export const {
  detectedSpeech,
  noSpeechDetected,
  stopDetectingSpeech,
  noSoundDetected,
  detectedSound,
  stopDetectingSound,
} = speechDetectorSlice.actions;

export default speechDetectorSlice.reducer;
